import React from "react";
import {
  Box,
  Paper,
  TextField,
  Button,
} from "@mui/material";
import { Save } from "@mui/icons-material";

const QuickTapsIntroSection = ({ introText, onIntroChange, onSave }) => {
  return (
    <Box sx={{ mt: 3, mb: 2 }}>
      <Paper sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <TextField
            value={introText}
            onChange={onIntroChange}
            multiline
            rows={1}
            fullWidth
            variant="outlined"
            label="Quick Taps Introduction"
            placeholder="Enter quick taps introduction text..."
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'white',
              }
            }}
          />
          <Button
            variant="contained"
            onClick={onSave}
            startIcon={<Save />}
            color="success"
          >
            Update
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default QuickTapsIntroSection;
